var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poiTypeContainer"},[_c('Toggle',{ref:"toggle",on:{"update:value":_vm.toggleUpdate}}),_c('ToggleLabel',{attrs:{"iconSrc":_vm.iconSrc,"name":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }